module.exports = __webpack_public_path__ + "img/conference_hall.832deec9.jpg";